import React from "react";
import classnames from "classnames";
import type { ComponentMessageType } from "../../../types/ComponentMessageType";
import styles from "../message.module.scss";

export const MessageLocation: React.FC<{ location: ComponentMessageType["location"]; testId?: string }> = ({ location, testId }) =>
  location?.preview && (
    <>
      <a
        className={classnames(styles.messageLocationPreview, { [styles.contrastTime]: !location.name })}
        href={`https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`}
        target="_blank"
        data-testid={`${testId}-preview`}
      >
        <img src={location.preview} alt={location.name ?? "location-preview"} className={styles.locationPreview} />
      </a>
      {location.name && (
        <a
          className={styles.messageLocationName}
          href={`https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`}
          target="_blank"
          data-testid={`${testId}-name`}
        >
          {location.name}
        </a>
      )}
    </>
  );
